export const API = {
  server: process.env.REACT_APP_API
}